import React from 'react';
import PropTypes from 'prop-types';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';

import messages from '../messages';
import { formatDate } from '../helpers';
import { Section, SectionLabel, ContextCard } from '../styles';
import ContextField from './ContextField';

const LearningContextSection = ({ learningContext }) => (
  <Section>
    <ContextCard>
      <SectionLabel>{intl.formatMessage(messages.learningContext)}</SectionLabel>
      <ContextField label={messages.productId} value={learningContext.productId} />
      <ContextField label={messages.productModel} value={learningContext.productModel} />
      <ContextField label={messages.productVersion} value={learningContext.productVersionId} />
      <ContextField label={messages.sourceId} value={learningContext.sourceId} />
      <ContextField label={messages.title} value={learningContext.title} />
      <ContextField label={messages.type} value={learningContext.learningContextType} />
      <ContextField label={messages.dateCreated} value={formatDate(learningContext.dateCreated)} />
      <ContextField label={messages.dateUpdated} value={formatDate(learningContext.dateModified)} />
    </ContextCard>
  </Section>
);

LearningContextSection.propTypes = {
  learningContext: PropTypes.object.isRequired,
};

export default LearningContextSection;
